export var ItemPriceRestriction;
(function(ItemPriceRestriction) {
    ItemPriceRestriction[/**
     * Redemption of a [[MemberReward]] with the specified [[MemberRewardItemPrice.rewardId]] is required.
     */ "MemberReward"] = "MemberReward";
    ItemPriceRestriction[/**
     * Redemption of a [[MemberReward]] with the specified [[MemberRewardItemPrice.rewardId]] on the top-level item is required.
     */ "InheritedMemberReward"] = "InheritedMemberReward";
    ItemPriceRestriction[/**
     * Redemption of the specified [[DiscountItemPrice.discountId]] is required.
     */ "Discount"] = "Discount";
    ItemPriceRestriction[/**
     * Redemption of the specified [[DiscountItemPrice.discountId]] on the top-level item is required.
     */ "InheritedDiscount"] = "InheritedDiscount";
})(ItemPriceRestriction || (ItemPriceRestriction = {}));

//# sourceMappingURL=item-price-restriction.js.map